import { render } from "./DotLoaders.vue?vue&type=template&id=153515db&scoped=true"
import script from "./DotLoaders.vue?vue&type=script&lang=js"
export * from "./DotLoaders.vue?vue&type=script&lang=js"

import "./DotLoaders.vue?vue&type=style&index=0&id=153515db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153515db"]])

export default __exports__